"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmount = exports.formatToOrdinal = void 0;
const constants_1 = require("./constants");
const formatToOrdinal = (amount, segment) => {
    // dayjs doesn't currently have a function for this which works with numbers over the 31st
    let ordinal;
    switch (segment) {
        case constants_1.Segment.Fixter_UK:
            ordinal = ['st', 'nd', 'rd'][(((((amount < 0 ? -amount : amount) + 90) % 100) - 10) % 10) - 1] || 'th';
            return amount.toString() + ordinal;
        case constants_1.Segment.Fixter_FR:
            ordinal = amount === 1 ? 'er' : 'ème';
            return amount.toString() + ordinal;
        default:
            return amount.toString();
    }
};
exports.formatToOrdinal = formatToOrdinal;
const formatAmount = (amount, segment, minimumFractionDigits = 2) => {
    let formattedAmount;
    switch (segment) {
        case constants_1.Segment.Fixter_FR:
            formattedAmount = amount.toLocaleString('fr-FR', {
                minimumFractionDigits,
            });
            return formattedAmount.toString();
        case constants_1.Segment.Fixter_UK:
        default:
            formattedAmount = amount.toLocaleString('gb-GB', {
                minimumFractionDigits,
            });
            return formattedAmount.toString();
    }
};
exports.formatAmount = formatAmount;
//# sourceMappingURL=numbers.js.map